'use client';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { SvgIcon } from '@s7/base';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const StoresQuadDownloadEn = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ jsxs(SvgIcon, _extends({
        width: 56,
        height: 56,
        fill: "none",
        viewBox: "0 0 56 56"
    }, props, {
        ref: ref,
        children: [
            /*#__PURE__*/ jsx("path", {
                fill: "#3DDC84",
                fillRule: "evenodd",
                d: "M34.116 4H21.87C16.118 4 14 6.11 14 11.875v12.246c0 5.766 2.11 7.876 7.875 7.876h12.246c5.766 0 7.879-2.11 7.879-7.876V11.875C41.99 6.11 39.882 4 34.116 4",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "#C4D600",
                fillRule: "evenodd",
                d: "M34.116 4H21.87C16.118 4 14 6.11 14 11.875v12.246c0 5.766 2.11 7.876 7.875 7.876h12.246c5.766 0 7.879-2.11 7.879-7.876V11.875C41.99 6.11 39.882 4 34.116 4",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "white",
                d: "m31.707 17.707-3 3a1 1 0 0 1-1.414 0l-3-3a.997.997 0 0 1 0-1.414 1 1 0 0 1 1.414 0L27 17.586V12a1 1 0 1 1 2 0v5.586l1.293-1.293a.999.999 0 1 1 1.414 1.414"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "white",
                d: "M20 22a1 1 0 1 1 2 0v1h12v-1a1 1 0 1 1 2 0v1a2 2 0 0 1-2 2H22a2 2 0 0 1-2-2zM31.452 55v-6.341h1.327v2.847h.08L35.2 48.66h1.476l-2.311 2.777L36.84 55h-1.59l-1.842-2.694-.629.756V55zM25.838 55v-6.341h2.615c1.336 0 2.228.861 2.228 2.166v.009c0 1.305-.892 2.166-2.228 2.166h-1.288v2zm2.29-5.291h-.963v2.254h.962c.76 0 1.209-.404 1.209-1.125v-.008c0-.721-.448-1.121-1.209-1.121M19.244 55l2.201-6.341h1.56L25.211 55h-1.397l-.47-1.538h-2.237L20.637 55zm2.944-5.076-.778 2.545h1.63l-.773-2.545zM44.395 46.075c-1.208 0-1.964-.945-1.964-2.492v-.009c0-1.555.738-2.491 1.964-2.491.664 0 1.204.325 1.446.852h.079v-2.623h1.283V46H45.92v-.751h-.08c-.25.523-.764.826-1.445.826m.435-1.064c.681 0 1.103-.536 1.103-1.424v-.008c0-.888-.426-1.433-1.103-1.433s-1.094.545-1.094 1.428v.009c0 .892.417 1.428 1.094 1.428M39.128 46.075c-.923 0-1.578-.572-1.578-1.45v-.01c0-.87.672-1.38 1.877-1.45l1.169-.07v-.4c0-.417-.286-.654-.813-.654-.462 0-.756.162-.857.448l-.01.017H37.73l.005-.04c.1-.847.9-1.41 2.118-1.41 1.283 0 2.008.607 2.008 1.64V46h-1.265v-.642h-.08c-.246.449-.755.717-1.388.717m-.325-1.53c0 .37.312.594.756.594.593 0 1.037-.391 1.037-.901v-.356l-.976.061c-.55.035-.817.242-.817.594zM34.827 46.101c-1.49 0-2.386-.945-2.386-2.518v-.009c0-1.56.91-2.518 2.386-2.518 1.477 0 2.387.954 2.387 2.518v.009c0 1.578-.897 2.518-2.387 2.518m0-1.006c.681 0 1.073-.558 1.073-1.512v-.009c0-.945-.396-1.511-1.073-1.511-.68 0-1.072.566-1.072 1.511v.009c0 .954.387 1.512 1.072 1.512M30.518 46v-6.688h1.283V46zM25.273 46v-4.838h1.283v.747h.08c.219-.523.698-.853 1.388-.853 1.076 0 1.656.66 1.656 1.815V46h-1.283v-2.839c0-.681-.281-1.041-.887-1.041-.594 0-.954.426-.954 1.08V46zM19.012 46l-1.292-4.838h1.297l.72 3.502h.08l.848-3.502h1.221l.853 3.502h.079l.72-3.502h1.27L23.522 46H22.16l-.866-3.375h-.08L20.358 46zM15.314 46.101c-1.49 0-2.386-.945-2.386-2.518v-.009c0-1.56.91-2.518 2.386-2.518s2.386.954 2.386 2.518v.009c0 1.578-.896 2.518-2.386 2.518m0-1.006c.681 0 1.072-.558 1.072-1.512v-.009c0-.945-.395-1.511-1.072-1.511-.681 0-1.072.566-1.072 1.511v.009c0 .954.386 1.512 1.072 1.512M7.01 46v-6.341h2.496c1.885 0 2.975 1.138 2.975 3.124v.009c0 2.048-1.076 3.208-2.975 3.208zm1.327-1.094h.958c1.173 0 1.833-.739 1.833-2.092v-.009c0-1.305-.681-2.052-1.833-2.052h-.958z"
            })
        ]
    })));

export { StoresQuadDownloadEn, StoresQuadDownloadEn as default };
//# sourceMappingURL=StoresQuadDownloadEn.js.map
